import {h, Fragment} from "preact"
import { useAppState, useFacets, useSelectedFiltersCount, useSort, useProductFilters } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import {Select} from "./elements/Select"
import SelectedFilters from "./SelectedFilters"
import Facet from "./Facet"

// function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
//     return (
//         <label
//             for={lableFor}
//             className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
//         >
//             <Icon name="filter" />
//             <span>Filter</span>
//             {selectedFiltersCount > 0 && (
//                 <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
//                     {selectedFiltersCount}
//                 </span>
//             )}
//         </label>
//     )
// }

export default function Toolbar({ lableFor, onToggle, isVisible }) {
    const { loading, query, response, pageType } = useAppState()
    const { facets } = useFacets();
    const { activeSort, setSort } = useSort(sortOptions)
    const { filters } = useProductFilters()
    const selectedFiltersCount = useSelectedFiltersCount() - filters?.filter(filter => filter.name === 'Tags - Hidden').length

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const backToCustomizer = event => {
        location.href = location.href.split("?")[0]
    }

    const isCustomizerPage = window.location.href.includes("/collections/customizer");
    const interest = facets.filter((facet) => { return facet.name == "Interests" })[0]

    const docCount = new Intl.NumberFormat('en-en').format( response.products?.total ) ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const fillStroke = selectedFiltersCount > 0 && window.innerWidth < 768 ? "white" : "#393d3c";

    let placeholder = "";
    if(isCustomizerPage && window.location.search.includes("q=")) {
        const urlParams = new URLSearchParams(window.location.search);
        placeholder = urlParams.get("q");
    }

    return (
        <>
        <div
            class="ns-toolbar-top"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {!loading && (
                <>
                    <div class={isCustomizerPage ? "ns-sidebar-header customizer" : "ns-sidebar-header"}>
                        {isCustomizerPage && interest ? (
                        //     <div class="customerizerFilters">
                        //         <span class="filterBy">Filter By:&nbsp;&nbsp;</span>
                        //         <span class="ns-sidebar-menu">
                        //             <ul class="ns-facet-list">
                        //                 <Facet key={interest?.id} facet={interest} />
                        //             </ul>
                        //         </span>
                        //     </div>
                        //     <div>
                        //     {/* <img src="https://d21m4dsqdd3b9h.cloudfront.net/shopify-68926472508/onsiteContent/17393699613780.0822872261255223" alt="back to full customizer page" /> */}
                        //     {/* <span class="backToCustomizer ns-toggle-sidebar" onClick={backToCustomizer}>Back To Customizer</span> */}
                        //     <span class="backToCustomizer ns-toggle-sidebar">Showing {docCount} result{docCount > 1 ? 's' : ''} {window.location.search.includes("q=") && `for "${placeholder}"`}</span>
                        //     <SelectedFilters />
                        //     {window.location.search.includes("q=") && <span class="backToCustomizer" style="text-decoration: underline;cursor:pointer;" onClick={backToCustomizer}>Clear Search</span>}
                        // </div>
                        <>  
                                { interest && (
                                    <div class="customerizerFilters">
                                        <span class="filterBy">Filter By:&nbsp;&nbsp;</span>
                                        <span class="ns-sidebar-menu">
                                            <ul class="ns-facet-list">
                                                <Facet key={interest?.id} facet={interest} />
                                            </ul>
                                        </span>
                                    </div>
                                )}
                                { (window.location.search.includes("q=") || filters.length > 0) && (
                                    <div>
                                        {/* <img src="https://d21m4dsqdd3b9h.cloudfront.net/shopify-68926472508/onsiteContent/17393699613780.0822872261255223" alt="back to full customizer page" /> */}
                                        {/* <span class="backToCustomizer ns-toggle-sidebar" onClick={backToCustomizer}>Back To Customizer</span> */}
                                        <span class="backToCustomizer ns-toggle-sidebar">Showing {docCount} result{docCount > 1 ? 's' : ''} {window.location.search.includes("q=") && `for "${placeholder}"`}</span>
                                        {window.location.search.includes("q=") && <span class="backToCustomizer" style="text-decoration: underline;cursor:pointer;" onClick={backToCustomizer}>Clear Search</span>}
                                    </div>
                                )}
                            </>
                        ) : (
                            <span class={selectedFiltersCount > 0 ? "ns-toggle-sidebar-selected" : "ns-toggle-sidebar"}
                                onClick={onToggle}
                            >
                                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="2" x2="13" y2="2" stroke={fillStroke} />
                                    <circle cx="9.5" cy="2" r="1" fill={fillStroke} stroke={fillStroke} />
                                    <line y1="6" x2="13" y2="6" stroke={fillStroke} />
                                    <circle cx="3.5" cy="6" r="1" fill={fillStroke} stroke={fillStroke} />
                                    <line y1="10" x2="13" y2="10" stroke={fillStroke} />
                                    <circle cx="9.5" cy="10" r="1" fill={fillStroke} stroke={fillStroke} />
                                </svg>
                                {isVisible ? "Hide Filters" : <span>Filters {selectedFiltersCount > 0 && `(${selectedFiltersCount})`}</span>}
                            </span>
                        )}
                        
                    </div>
                    <div class={`${pageType === "search" ? "ns-toolbar-right" : "ns-toolbar-right-end"}`}>
                        {pageType === "search" && (
                            <span
                                class="ns-search-results-text"
                                data-nosto-element="totalResults"
                            >
                                Search results for <span class="ns-search-results-query">"{query.query}"</span>
                            </span>
                        )}

                        {isCustomizerPage ? (
                            <form name="customizerSearch" class="c-form c-form--minWidth c-form--marginTopSmallViewportsOnly u-border u-border--bottom u-border--trblSmallViewport js-search" role="search" action="/collections/customizer" method="get" novalidate="novalidate" onSubmit={(e)=>{
                                if(document.getElementById('customizerq').value === ''){
                                    e.preventDefault()
                                    window.location.href = "https://lifeisgood.com/collections/customizer";
                                }
                            }}>
                                <fieldset>
                                    <legend class="u-hiddenAccessible">
                                        Search custom products
                                    </legend>
                                    <label id="customizerqlabel" class="u-hiddenAccessible">
                                        Search custom products
                                    </label>
                                    <input type="text" id="customizerq" name="q" aria-labelledby="customizerqlabel" class="c-formField c-formField--borderNone c-formField--boxShadowNone c-formField--small u-marginBottomNone u-paddingTopNone c-formField--customizerSearch qa-input--customizerSearch--customizerSearch valid" value={placeholder} placeholder="Search Customizer" aria-invalid="false" />
                                    {/* <input type="hidden" name="filter.categories" value="Customizer" /> */}
                                    <button type="submit" class="c-icon c-icon--formField u-hiddenSmallViewport qa-button--customizersearch qa-hover--customizerSearch" value="Search custom products">
                                        <svg class="c-icon__svg is-svg" width="21px" height="20px" viewBox="0 0 21 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <title>Search</title>
                                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g transform="translate(-879.000000, -59.000000)" fill="#0A4875" fill-rule="nonzero">
                                                    <g transform="translate(461.500000, 51.000000)">
                                                        <path fill="#000" d="M437.724636,25.2912801 L433.830485,21.3971292 C433.654721,21.2213651 433.416463,21.1237184 433.166488,21.1237184 L432.529831,21.1237184 C433.607851,19.7449468 434.248413,18.0107411 434.248413,16.1242066 C434.248413,11.6363636 430.61205,8 426.124207,8 C421.636364,8 418,11.6363636 418,16.1242066 C418,20.6120496 421.636364,24.2484132 426.124207,24.2484132 C428.010741,24.2484132 429.744947,23.6078508 431.123718,22.5298311 L431.123718,23.1664876 C431.123718,23.4164632 431.221365,23.6547212 431.397129,23.8304853 L435.29128,27.7246363 C435.658432,28.0917879 436.252124,28.0917879 436.61537,27.7246363 L437.72073,26.6192755 C438.087882,26.2521238 438.087882,25.6584318 437.724636,25.2912801 Z M426.124207,21.1237184 C423.362758,21.1237184 421.124695,18.8895616 421.124695,16.1242066 C421.124695,13.3627575 423.358852,11.1246949 426.124207,11.1246949 C428.885656,11.1246949 431.123718,13.3588517 431.123718,16.1242066 C431.123718,18.8856557 428.889562,21.1237184 426.124207,21.1237184 Z"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </button>
                                    <button type="submit" class="c-icon c-icon--formField u-hiddenMediumLargeViewport" value="Search custom products">
                                        <svg class="c-icon__svg is-svg" width="21px" height="20px" viewBox="0 0 21 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <title>Search</title>
                                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g transform="translate(-879.000000, -59.000000)" fill="#0A4875" fill-rule="nonzero">
                                                    <g transform="translate(461.500000, 51.000000)">
                                                        <path fill="#000" d="M437.724636,25.2912801 L433.830485,21.3971292 C433.654721,21.2213651 433.416463,21.1237184 433.166488,21.1237184 L432.529831,21.1237184 C433.607851,19.7449468 434.248413,18.0107411 434.248413,16.1242066 C434.248413,11.6363636 430.61205,8 426.124207,8 C421.636364,8 418,11.6363636 418,16.1242066 C418,20.6120496 421.636364,24.2484132 426.124207,24.2484132 C428.010741,24.2484132 429.744947,23.6078508 431.123718,22.5298311 L431.123718,23.1664876 C431.123718,23.4164632 431.221365,23.6547212 431.397129,23.8304853 L435.29128,27.7246363 C435.658432,28.0917879 436.252124,28.0917879 436.61537,27.7246363 L437.72073,26.6192755 C438.087882,26.2521238 438.087882,25.6584318 437.724636,25.2912801 Z M426.124207,21.1237184 C423.362758,21.1237184 421.124695,18.8895616 421.124695,16.1242066 C421.124695,13.3627575 423.358852,11.1246949 426.124207,11.1246949 C428.885656,11.1246949 431.123718,13.3588517 431.123718,16.1242066 C431.123718,18.8856557 428.889562,21.1237184 426.124207,21.1237184 Z"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </button>
                                </fieldset>
                            </form>
                        ) : (
                            <div class="ns-select-container">
                                <span class="ns-select-container-product-count">{docCount} Product{docCount === '1' ? '' : 's'}</span>
                                <Select
                                    value={activeSort}
                                    onChange={e => handleSortChange(e)}
                                    className="ns-selection-dropdown-sort-menu"
                                    options={options}
                                />
                            </div>
                        )}
                    </div>
                    { !isCustomizerPage && (
                        <div class="ns-selected-filters-m">
                            <SelectedFilters/>
                        </div>
                    )}
                </>
            )}

        </div>
        {isCustomizerPage && (
            <div class={`ns-sidebar-header customizer ns-toolbar-additional-info ${filters.length > 0 ? 'ns-with-filters' : ''}`}>                
                { (window.location.search.includes("q=") || filters.length > 0) && <SelectedFilters />}
            </div>
        )}
        
        </>
    )
}
